/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//--------- Paypal Popup JS 
document.addEventListener('DOMContentLoaded', function () {
  
    const paypalInstallmentBar = document.querySelector('.paypal_installment_bar');
    const paypal_popup_close = document.querySelector('.paypal_popup_close');
    const paypal_popup_overlay = document.querySelector('.paypal_popup_overlay');
    if (paypalInstallmentBar) {
        paypalInstallmentBar.addEventListener('click', function () {
          const paypalInstallmentPopup = document.querySelector('.paypal_installment_popup');
          paypalInstallmentPopup.classList.add('active');
        });
    }
    if (paypal_popup_close) {
        paypal_popup_close.addEventListener('click', function () {
          const paypalInstallmentPopup = document.querySelector('.paypal_installment_popup');
          paypalInstallmentPopup.classList.remove('active');
        });
    }
    if (paypal_popup_overlay) {
        paypal_popup_overlay.addEventListener('click', function () {
          const paypalInstallmentPopup = document.querySelector('.paypal_installment_popup');
          paypalInstallmentPopup.classList.remove('active');
        });
    }

        //--------------------- product Variant Popup ---------------------
        var variant_popup_main = document.querySelector(".product_variant_popup_main");
        if(variant_popup_main){
                document.querySelectorAll(".pdp_variant_popup_close").forEach(button => {
                    button.addEventListener("click", function () {
                      let parentPopup = this.closest(".pdp_variant_popup");
                      if (parentPopup) {
                          parentPopup.classList.remove("active_popup");
                      }
                      document.querySelector('.pdp_variant_popup_overlay').style.display = 'none';
                    });
                });
        
                document.querySelector(".pdp_variant_popup_overlay").addEventListener("click", function () {
                  document.querySelector(".pdp_variant_popup.active_popup").classList.remove("active_popup");
                  this.style.display = 'none';
                });
              
                document.querySelectorAll(".varint_popup_label").forEach(label => {
                    label.addEventListener("click", function () {
                        document.querySelector('.pdp_variant_popup').classList.add("active_popup");
                        document.querySelector('.pdp_variant_popup_overlay').style.display = 'block';
                    });
                });
        
                document.querySelectorAll(".varint_popup_item").forEach(item => {
                    item.addEventListener("click", function () {
                      
                        let parentPopup = this.closest(".pdp_variant_option");
                        let selectedItem = parentPopup.querySelector(".varint_popup_item.selected");
                        if (selectedItem) {
                            selectedItem.classList.remove("selected");
                        }
                        this.classList.add("selected");
                      
                        let targetElement = document.querySelector(`.block-swatch__item[title="${this.getAttribute('option_value')}"]`);
                        if (targetElement) {
                            targetElement.click();
                        }
                      
                        if (parentPopup) {
                            let popupId = parentPopup.getAttribute("popup");
                            let labelElement = document.querySelector(`.varint_popup_label[popup="${popupId}"] .varint_popup_selected_name`);
                            
                            if (labelElement) {
                                labelElement.innerHTML = this.getAttribute("option_value");
                            }
                        }
                    });
                });
        
                document.querySelectorAll(".varint_popup_item_n").forEach(item => {
                    item.addEventListener("click", function () {
                      
                        let parentPopup = this.closest(".pdp_variant_option");
                        let selectedItem = parentPopup.querySelector(".varint_popup_item_n.selected");
                        if (selectedItem) {
                            selectedItem.classList.remove("selected");
                        }
                        this.classList.add("selected");
                      
                        let targetElement = document.querySelector(`.block-swatch__item[title="${this.getAttribute('option_value')}"]`);
                        if (targetElement) {
                            targetElement.click();
                        }
                      
                        if (parentPopup) {
                            let popupId = parentPopup.getAttribute("popup");
                            let labelElement = document.querySelector(`.varint_popup_label[popup="${popupId}"] .varint_popup_selected_name`);
                            
                            if (labelElement) {
                                labelElement.innerHTML = this.getAttribute("option_value");
                            }
                        }
                    });
                });
        }
  
});

function updateCartQuantity(selectElement) {
    var newQuantity = parseInt(selectElement.value);
    var lineItemId = parseInt(selectElement.getAttribute('data_id'));

    const data = {
        updates: {
            [lineItemId]: newQuantity
        }
    };

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(cart => {
        //console.log("Cart updated successfully:", cart);
        // Dispatch a custom event to refresh the cart
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        }));
    })
    .catch((error) => {
        console.error("Error updating cart:", error);
    });
}

document.addEventListener("DOMContentLoaded", function() {
  // Cache references for elements used in multiple places
  //const freeShippingBar = document.querySelector('.free_shipping_bar');
  const miniCartElement = document.getElementById('mini-cart');
  
  // Helper function to fetch cart data
  function fetchCartData() {
    return fetch('/cart.js')
      .then(response => response.json())
      .catch(error => {
        console.error('Error fetching cart data:', error);
        throw error;
      });
  }

  // Helper function to update the cart
  function updateCart(updates) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
      .then(response => response.json())
      .catch((error) => {
        console.error('Error updating the cart:', error);
        throw error;
      });
  }

  // Helper function to add product to the cart
  function addToCart(productId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: 1,
        id: productId
      })
    })
      .then(response => response.json())
      .catch((error) => {
        console.error('Error adding product to cart:', error);
        throw error;
      });
  }

  // Helper function to remove products from the cart
  function removeFromCart(productIds) {
    let updates = {};
    productIds.forEach(id => updates[id] = 0);
    return updateCart(updates);
  }

  // MutationObserver to detect changes in mini-cart
  const observer = new MutationObserver(mutationsList => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList') {
        console.log('Child nodes in mini-cart have changed.');
        setTimeout(() => {
                    const freeShippingBar = document.querySelector('.body_variant_b .free_shipping_bar');
                    if(freeShippingBar){
                    const productThreshold1 = freeShippingBar.getAttribute('product_thersold_1');
                    const productId1 = freeShippingBar.getAttribute('product_id_1');
                    const productThreshold2 = freeShippingBar.getAttribute('product_thersold_2');
                    const productId2 = freeShippingBar.getAttribute('product_id_2');
          
                    if (!productId1 && !productId2) return;
          
                     console.log('running...');
          
                    fetchCartData().then(cart => {
                      //console.log(cart);
                      const cartTotal = cart.total_price;
                      let product1Available = true;
                      let product2Available = true;
          
                      // Handle product 2 logic
                      if (cartTotal > productThreshold2 && productId2) {
                        cart.items.forEach(item => {
                          if (item.variant_id == productId1) {
                            let updates = {};
                            updates[item.variant_id] = 0;
                            updateCart(updates).then(() => {
                              console.log('Product 1 removed.')
                              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                            });
                          }
                          if (item.variant_id == productId2) {
                            product2Available = false;
                          }
                        });
                        if (product2Available) {
                          addToCart(productId2).then(() => {
                            console.log('Product 2 added.');
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                          });
                        }
                      }
          
                      // Handle product 1 logic
                      if (cartTotal > productThreshold1 && productId1) {
                        console.log('triggered');
                        cart.items.forEach(item => {
                          if (item.variant_id == productId1) {
                            product1Available = false;
                          }
                          if (item.variant_id == productId2) {
                            if(cartTotal > productThreshold2){
                               product1Available = false; 
                            }else{
                                let updates = {};
                                updates[item.variant_id] = 0;
                                updateCart(updates).then(() => {
                                  console.log('Product 2 removed.')
                                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                                });
                            }
                          }
                        });
                        if (product1Available) {
                          addToCart(productId1).then(() => {
                            console.log('Product 1 added.');
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                          });
                        }
                      }
          
                      // Handle both products removal
                      else {
                        let productIdsToRemove = [];
                        cart.items.forEach(item => {
                          if (item.variant_id == productId1 || item.variant_id == productId2) {
                            productIdsToRemove.push(item.variant_id);
                          }
                        });
                        if (productIdsToRemove.length > 0) {
                          removeFromCart(productIdsToRemove).then(() => {
                            console.log('Products removed from cart.');
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                          });
                        }
                      }
                    });
                    }
        }, 400);
      }
    });
  });

  // Set up the observer for the mini-cart
  if (miniCartElement) {
    const config = { attributes: true, childList: true, subtree: true };
    observer.observe(miniCartElement, config);
  }

  //-------------------------------- Collection Page Redesign ------------------------------------
  document.addEventListener('click', function(event) {
    if (event.target.closest('.collection__filter-group-btn')) {
      document.querySelectorAll('.collection__filter-group-btn').forEach(function(button) {
          const filterGroup = button.closest('.collection_horizontal_filter-group');
          if (filterGroup) {
            filterGroup.classList.remove('active_filter');
          }
      });
      const button = event.target.closest('.collection__filter-group-btn');
      const filterGroup = button.closest('.collection_horizontal_filter-group');
      if (filterGroup) {
        filterGroup.classList.toggle('active_filter');
      }
    }else{
      document.querySelectorAll('.collection__filter-group-btn').forEach(function(button) {
          const filterGroup = button.closest('.collection_horizontal_filter-group');
          if (filterGroup) {
            filterGroup.classList.remove('active_filter');
          }
      });
    }
  });
  //-------------------------------- Collection Page Redesign ------------------------------------

  // PDP quantity append to buy buttons
  const moveQuantityInterval = setInterval(() => {
    const quantityContainer = document.querySelector('#buy_quantity');
    const quantityElement = document.querySelector('.product-form__info-item--quantity');

    if (quantityContainer && quantityElement) {
      quantityContainer.appendChild(quantityElement);
      clearInterval(moveQuantityInterval);
    }
  }, 200);

  const interval = setInterval(() => {
    const amountEl = document.querySelector('#cashback-amount');
    const headingEl = document.querySelector('.cashback-heading');
  
    if (amountEl && amountEl.textContent.trim() !== '' && headingEl) {
      const amountText = amountEl.textContent.trim();
  
      if (!headingEl.textContent.startsWith(amountText)) {
        headingEl.textContent = `${amountText} ${headingEl.textContent.trim()}`;
      }
  
      clearInterval(interval);
    }
  }, 500);


});


